import React, { createContext, useContext, useState, useCallback } from 'react';

const ToolResultContext = createContext();

export function ToolResultProvider({ children }) {
  const [toolResult, setToolResult] = useState(null);

  const publishResult = useCallback((toolName, summary) => {
    setToolResult({ toolName, summary, timestamp: Date.now() });
  }, []);

  const clearResult = useCallback(() => setToolResult(null), []);

  return (
    <ToolResultContext.Provider value={{ toolResult, publishResult, clearResult }}>
      {children}
    </ToolResultContext.Provider>
  );
}

export function useToolResult() {
  return useContext(ToolResultContext);
}
